/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";

  var search = function search() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'find.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        drawDateFrom: $("#drawDateFrom").val(),
        drawDateTo: $("#drawDateTo").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        receipt = "";
        var data = JSON.parse(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          console.log("receipt length" + data.receipts.length);

          for (var i = 0; i < data.receipts.length; i++) {
            receipt += "\n              <div class=\"card\">\n                <div class=\"card-content card-content-padding\">\n                  <table width=100%>\n                    <thead>\n                      <tr>\n                        <th style=\"text-align:left\">\n                          <span class='en'>Date</span>\n                          <span class='cn'>\u65E5\u671F</span>\n                          <span class='tl'>Data</span>\n                        </th>\n                        <th style=\"text-align:left\">\n                          <span class='en'>Order ID</span>\n                          <span class='cn'>\u8BA2\u5355\u7F16\u53F7</span>\n                          <span class='tl'>Hameno ID</span>\n                        </th>\n                        <th style=\"text-align:left\"></th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td style=\"text-align:left\" width=\"50%\">" + data.receipts[i].dateTime + "</td>\n                        <td style=\"text-align:left\">" + data.receipts[i].orderID + "</td>\n                        <td style=\"text-align:left\"><button class=\"button button-fill button-view\" id=\"" + data.receipts[i].orderID + "\">\n                          <span class='en' id=\"" + data.receipts[i].orderID + "\">View</span>\n                          <span class='cn' id=\"" + data.receipts[i].orderID + "\">\u770B</span>\n                          <span class='tl' id=\"" + data.receipts[i].orderID + "\">Hare</span>\n                        </button></td>\n                      </tr> \n                    </tbody> \n                  </table>\n                  </div> \n              </div>\n\n              ";
          }

          $update();
        } else {
          $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  $on('pageInit', function () {
    document.getElementById('drawDateFrom').valueAsDate = new Date();
    document.getElementById('drawDateTo').valueAsDate = new Date();
    $(document).on("click", ".button-view", function (e) {
      window.orderId = e.srcElement.id;
      console.log(window.orderId);
      console.log(e.srcElement);
      window.origin = "bet_list";
      $f7.views.current.router.navigate("/cashier_receipt/", {
        force: true
      });
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
            <span class='en'>Back</span>
            <span class='cn'>返回</span>
            <span class='tl'>Fila</span>
          </span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Bet List</span>
        <span class='cn'>投注清单</span>
        <span class='tl'>Lista jogu</span>
      </div>
    </div>
  </div>
  <div class="page-content">

    <div class="block">
      
        <span class='en'>Please select the FROM and TO date to list the betting.</span>
        <span class='cn'>请选择开始和结束日期以列出投注。</span>
        <span class='tl'>Favor hili data husi komesa to data remata nebe atu tau iha ita nia taru</span>
      
    </div>


    <div class="block-title">
      <span class='en'>Draw Date</span>
      <span class='cn'>抽奖日期</span>
      <span class='tl'>Data soe </span>
    </div>
    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>From</span>
              <span class='cn'>开始</span>
              <span class='tl'>Husi</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="drawDateFrom"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>To</span>
              <span class='cn'>结束</span>
              <span class='tl'>Ba</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="drawDateTo"/>
            </div>
          </div>
        </li>   
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
        
      </ul>
    </div>


    <div class="block-title">
      
      <span class='cn'></span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div innerHTML=${receipt}>

    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '0cfb7f20f0';
export default framework7Component;